import { makeEntityScaffold } from '@classpass/saga-tools';
import { SmartSpotOpportunitiesResponse } from '@classpass/protobuf-definitions/lib/web/models/partners/smartspot_opportunities';
import { transformKeysToCamelCase } from 'helpers/core';

import URLS from 'constants/urls';

const get = (httpClient, venueId) => {
  const endpoint = URLS.venue.smartSpotOpportunities(venueId);

  return httpClient
    .get(endpoint)
    .then(response => {
      // Deserialize proto response
      const deserialized = SmartSpotOpportunitiesResponse.fromJSON(response.data);
      // Transform snake_case keys to camelCase for each opportunity object
      const transformedOpportunities = transformKeysToCamelCase(deserialized.opportunities || []);
      // SmartSpot opportunities are always schedule-level (not class-level)
      // and already have the opportunitySource field set to 'SMARTSPOT'
      return transformedOpportunities;
    })
    .catch(() => {
      // If endpoint fails (e.g., 404), return empty array to avoid breaking the app
      return [];
    });
};

const handler = ({ httpClient }, { venueId }) => {
  return get(httpClient, venueId);
};

export default makeEntityScaffold('SAGA.API.VENUE.SMARTSPOT_OPPORTUNITIES', handler, {
  defaultKey: (_, { venueId }) => venueId,
});
